module.exports = __webpack_public_path__ + "resources/img/img_intro_certi1.b45084312d7783ac506d4d3194c3fe37.png";